import React, { useEffect, useState } from "react";
import { Button, Select } from "antd";

import InsurancePatientProceduresTable from "./InsurancePatientProceduresTable";
import arrowDown from "../../assets/icons/arrow-down12.png";

export default function InsurancePatientSubTable({
  predeterminationOrPostPayment,
  approvedPredeterminations,
  handleApprovePostPayment,
  handleApproveInsurance,
  isPatientDropdownEmpty,
  setSelectedPaymentType,
  isApprovingInsurance,
  selectedPaymentType,
  setMarkedProcedures,
  selectedInsurance,
  approvedPatients,
  selectedPatients,
  insuranceStatus,
  allPaymentTypes,
  allProcedures,
  isApproved,
  loading,
  record,
}) {
  const [emptyProcedureDropdowns, setEmptyProcedureDropdown] = useState({});
  const [approvedProcedures, setApprovedProcedures] = useState({});
  const [isSettingProcedureCode, setIsSettingProcedureCode] = useState(false);
  const [isOpenDropdowns, setOpenDropdowns] = useState([]);
  const [matchPaymentType, setMatchPaymentType] = useState(undefined);

  const paymentTypeOptions = allPaymentTypes.map((paymentType) => ({
    value: paymentType.id,
    label: paymentType.name ? paymentType.name : paymentType.description,
  }));

  useEffect(() => {
    const patientPaymentType = record.insurances.every((insurance) => insurance.payment_type === record.insurances[0].payment_type);

    if (patientPaymentType) {
      setMatchPaymentType(allPaymentTypes.find((paymentType) => paymentType.id === record.insurances[0].payment_type));
      setSelectedPaymentType(record.insurances[0].payment_type);
    }
  }, [record.insurances, allPaymentTypes, setSelectedPaymentType]);

  function handleTogglePaymentTypeDropdown(patientID) {
    if (isOpenDropdowns.includes(patientID)) {
      setOpenDropdowns((prevIDs) => prevIDs.filter((id) => id !== patientID));
    } else {
      setOpenDropdowns((prevIDs) => [...prevIDs, patientID]);
    }
  }

  // Approve button logic
  const isInsuranceApproved =
    insuranceStatus === "approved" ||
    insuranceStatus === "accepted" ||
    isApproved ||
    approvedPatients.includes(record.id) ||
    record.insurances.every((insurance) => insurance.is_approved === true) ||
    (predeterminationOrPostPayment === "predetermination" && approvedPredeterminations.includes(record.id));

  const isInsurancePendingAndDropdownsFilled =
    selectedInsurance.status === "pending" &&
    !isPatientDropdownEmpty &&
    (!emptyProcedureDropdowns[record.id] || emptyProcedureDropdowns[record.id].length === 0);

  let isButtonDisabled =
    isInsuranceApproved ||
    isApprovingInsurance.includes(record.id) ||
    !isInsurancePendingAndDropdownsFilled ||
    (predeterminationOrPostPayment === "predetermination" && approvedPredeterminations.includes(record.id));

  const buttonStyle = {
    backgroundColor: isInsuranceApproved ? "rgba(4, 201, 0, 0.1)" : isInsurancePendingAndDropdownsFilled ? "#6B43B5" : "#F5F5F5",
    color: isInsuranceApproved ? "#04C900" : isInsurancePendingAndDropdownsFilled ? "white" : "#848696",
    border: isInsuranceApproved ? "none" : isInsurancePendingAndDropdownsFilled ? "1px solid #6B43B5" : "1px solid #d9d9d9",
    padding: "20px 50px",
    marginLeft: "auto",
  };

  let buttonText = isInsuranceApproved ? "Approved" : loading || isApprovingInsurance.includes(record.id) ? "Loading..." : "Approve";

  return (
    <div className="inner-area-insurance-procedure">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
        <p style={{ fontSize: 18, marginBottom: 0 }}>Insurance Details</p>

        {predeterminationOrPostPayment === "post_payment" && (
          <Select
            showSearch
            placeholder="Select Payment Type"
            optionFilterProp="label"
            options={paymentTypeOptions}
            className={`select-patient-id ${selectedPaymentType && "no-transparent-background"}`}
            value={matchPaymentType && (matchPaymentType.name || matchPaymentType.description)}
            suffixIcon={
              <img
                style={{ width: 20, transform: `rotate(${isOpenDropdowns.includes(record.id) ? "180deg" : "0"})` }}
                src={arrowDown}
                alt="arrow-down"
              />
            }
            onChange={(value) => setSelectedPaymentType(value)}
            onOpenChange={() => handleTogglePaymentTypeDropdown(record.id)}
            disabled={isApproved || approvedPatients.includes(record.id) || record.insurances.every((insurance) => insurance.is_approved === true)}
            filterOption={(input, option) => {
              if (!input) return true;
              if (!option.label) return false;

              return (
                (option.label.props && option.label.props.name && option.label.props.name.toLowerCase().includes(input.toLowerCase())) ||
                (option.label.props && option.label.props.email && option.label.props.email.toLowerCase().includes(input.toLowerCase())) ||
                (option.label.props && option.label.props.phone && option.label.props.phone.toString().toLowerCase().includes(input.toLowerCase()))
              );
            }}
          />
        )}
      </div>
      {record.insurances && record.insurances.length > 0 ? (
        <>
          <InsurancePatientProceduresTable
            predeterminationOrPostPayment={predeterminationOrPostPayment}
            disabledByApproved={selectedInsurance.status === "approved"}
            setEmptyProcedureDropdown={setEmptyProcedureDropdown}
            setIsSettingProcedureCode={setIsSettingProcedureCode}
            isSettingProcedureCode={isSettingProcedureCode}
            setApprovedProcedures={setApprovedProcedures}
            setMarkedProcedures={setMarkedProcedures}
            approvedProcedures={approvedProcedures}
            approvedPatients={approvedPatients}
            insurances={record.insurances}
            allProcedures={allProcedures}
            currentPatientID={record.id}
          />

          <div style={{ marginTop: 30, display: "flex" }}>
            <Button
              type="primary"
              onClick={() =>
                predeterminationOrPostPayment === "predetermination"
                  ? handleApproveInsurance(selectedPatients[record.id], record)
                  : handleApprovePostPayment(record.id)
              }
              disabled={isButtonDisabled}
              style={buttonStyle}
              className={`${isInsuranceApproved ? "approved-button" : ""}`}
            >
              {buttonText}
            </Button>
          </div>
        </>
      ) : (
        <p>No insurance records found</p>
      )}
    </div>
  );
}
